<template>
  <div>
    <el-dialog :title="isLadingPay ? $t('equipment.prepayFreight') : $t('equipment.payment')" custom-class="MyDialog" :visible.sync="isShowBankRransferDialog" :close-on-click-modal="false"
      @close="closeBankRransfer" width="1000px">
      <!-- 提货单支付信息 -->
      <div v-if="payInfo.ladingNo" class="purchase-info">
        <div class="textOne">
          <span>提货单号：{{ payInfo.ladingNo }}</span>
          <span>下单时间：{{ payInfo.ladingCreateTime }}</span>
        </div>
        <div class="textTwo">
          <span>{{ $t('app.auto_179_71c7a446') }}：<span :style="{ color: 'red' }">{{
            payInfo.orderAmount
          }}</span>{{ $t('purchasing.yuan') }}</span>
          <span>{{ $t('app.auto_182_b06ed898') }}：<span :style="{ color: 'red' }">{{
            payInfo.receivedAmount
          }}</span></span>
        </div>
      </div>
      <div v-else class="purchase-info">
        <div class="textOne">
          <span>采购单号：{{ payData.orderNo }}</span>
          <span>下单时间：{{ payData.orderCreateTime }}</span>
        </div>
        <div class="textTwo">
          <span>采购量：{{ payData.buyNum }}{{orderType == 'callCenter' ? '个' : '台'}}</span>
          <span>{{ $t('app.auto_181_f43952fb') }}：<span :style="{ color: 'red' }">{{
            payData.orderAmount
          }}</span></span>
          <span>{{ $t('app.auto_180_263ed7bb') }}：<span :style="{ color: 'red' }">{{
            payData.receivedAmount
          }}</span></span>
        </div>
      </div>
      <div class="PaytoSongShu">
        <div class="right_content">
          <b>{{ companyInfo.companyName }}</b>
          <b>银行账号：{{ companyInfo.bankAccount }}</b>
          <b>开户行：{{ companyInfo.bankName }}</b>
        </div>
      </div>
      <el-row>
        <el-col :span="24">
          <el-form :model="bankRransferForm" ref="bankRransferForm" label-width="100px">
            <el-row>
              <el-col :span="12">
                <el-form-item :label="$t('equipment.transferAmount') + '：'" prop="money">
                  <el-input v-model="bankRransferForm.money" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('equipment.payTimeLabel') + '：'" prop="payTime" :rules="[
                  { required: true, message: this.$t('equipment.payTimeRequired'), trigger: 'blur' }
                ]">
                  <el-date-picker v-model="bankRransferForm.payTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%"
                    :placeholder="$t('equipment.pleaseSelectPayTime') + '：'">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item :label="$t('equipment.paySerialNo')" prop="paySysNo">
              <el-input :placeholder="$t('equipment.pleaseEnterPaySerialNo')" v-model="bankRransferForm.paySysNo"></el-input>
            </el-form-item>
			<el-form-item
              :label="$t('equipment.payVoucher') + '：'"
              prop="fileList"
              :rules="[
                {
                  required: bankRransferForm.fileUrl != '' ? false : true,
                  message: this.$t('equipment.payVoucherRequired')
                }
              ]"
            >
              <div>
                <span>{{ $t('app.auto_183_bd0c8844') }}</span>
                <a class="credential-instance" @click="previewImage"
                  >{{ $t('app.auto_184_b68fb5c2') }}</a
                >
              </div>
              <el-upload
                ref="upload"
                :class="['upload-demo', {hide_box: upload_btn}]"
                action="#"
                accept=".jpg,.jpeg,.png"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :on-change="handleSetUploadData"
                multiple
                :limit="1"
                :auto-upload="false"
                :on-exceed="handleExceed"
                :file-list="fileList"
                list-type="picture-card"
              >
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{ file }">
                  <img
                    class="el-upload-list__item-thumbnail"
                    :src="file.url"
                    alt=""
                  />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      v-if="!disabled"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item :label="$t('equipment.payRemark') + '：'" prop="remark">
              <el-input type="textarea" v-model="bankRransferForm.remark" :placeholder="$t('equipment.pleaseEnterPayRemark')" maxlength="500"
                :autosize="{ minRows: 4, maxRows: 8 }" show-word-limit></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeBankRransfer">取 消</el-button>
        <el-button type="primary" @click="submitPay('bankRransferForm')">{{ $t('app.auto_185_1f46ba2d') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog width="30%" :visible.sync="showImageDemo">
      <img class="preview-demo-image" src="@/assets/images/agent/demo.png" />
    </el-dialog>
	<el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { bankRransferPay, purchaseOrderPay, ladingPay, queryLadingPayInfo } from "@/api/AccountInterface";
import { getBaseUrl } from "@/util/config";
import axios from "axios";
import LoginUserHelper from "@/util/LoginUserHelper";

export default {
  data() {
    return {
      bankRransferForm: {
        money: "",
        payTime: "",
        paySysNo: "",
        remark: "",
        fileUrl: ""
      },
      rules: {
        payTime: [
          { required: true, message: this.$t('equipment.pleaseSelectPayTime'), trigger: "blur" }
        ]
      },
      isShowBankRransferDialog: false,
      fileList: [],
      showImageDemo: false,
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      upload_btn: false,
      payInfo: {}, // 支付信息
    };
  },
  props: {
    bankRransferDialogVisible: {
      type: Boolean,
      default: false
    },
    payData: {
      type: Object,
      default: {}
    },
    formLabelAlign: {
      type: Object,
      default: {}
    },
    companyInfo: {
      type: Object,
      default: {}
    },
    orderType: {
      type: String,
      default: ""
    },
    purchaseOrderPay: {
      type: Boolean, // 支付接口区分
      default: true
    }
  },
  watch: {
    bankRransferDialogVisible: {
      handler(newValue, oldValue) {
        this.isShowBankRransferDialog = newValue;
        this.fileList = [];
      },
      immediate: true
    },
    formLabelAlign: {
      handler(newValue, oldValue) {
        if (newValue.elsePayMoney) {
          this.bankRransferForm.money = newValue.elsePayMoney;
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.isLadingPay && this.queryOrderInfo();
  },
  computed: {
    isPurchaseOrderPay() {
			return this.$route.path.includes('SubSubscriptionCard') || this.$route.path.includes('purchasing')|| this.$route.path.includes('GuinnessCertificate') || this.$route.path.includes('outboundCostCenter') || this.purchaseOrderPay
		},
		isLadingPay() {
			return this.$route.path.includes('DeliveryCreation') || this.$route.path.includes('TakeDelivery')
		}
	},
  methods: {
    queryOrderInfo() {
      queryLadingPayInfo({ ladingNo: this.payData.orderNo || this.payData.ladingNo }).then(ret => {
        if (ret.code === 0) {
          this.payInfo = ret.data;
        }
      })
    },
    handlePictureCardPreview(file) {
      // console.log(file);
      // console.log(this.dialogImageUrl);
      // console.log(this.fileList);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 取消
    closeBankRransfer() {
      // this.isShowBankRransferDialog = false;
      this.$emit("closeBankRransfer");
    },

    // 线上订单：https://agent-manage.songshuai.com/api/manage/purchase/order/pay
    // 赊货订单：https://agent-manage.songshuai.com/api/manage/credit/order/pay
    // 订阅卡采购：https://agent-manage.songshuai.com/api/manage/purchase/order/pay
    // purchaseOrderPay:api/manage/purchase/order/pay
    // bankRransferPay:api/manage/credit/order/pay

    compatible_Pay(params) {
      if (this.isLadingPay) {
        return ladingPay(params)
      } else if (this.isPurchaseOrderPay) {
        return purchaseOrderPay(params)
      } else {
        return bankRransferPay(params)
      }
    },
    // 支付
    submitPay(formName) {
      const list = [];
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.bankRransferForm.fileUrl != "") {
            list.push(this.bankRransferForm.fileUrl);
          }
          const {
            accountPayMoney,
            deliveryMoney,
            voucherAccountPayMoney,
            totalGoldPayMoney,
            elsePayMoney,
            promoteMoney,
          } = this.formLabelAlign;
          const { money, paySysNo, payTime, remark } = this.bankRransferForm;
          this.compatible_Pay({
            agentMoney: accountPayMoney,
            realTimeMoney: 0,
            bankInfo: {
              fileUrl: list,
              money: money,
              paySysNo: paySysNo,
              payTime: payTime,
              remark: remark
            },
            orderNo: this.payData.orderNo || this.payData.ladingNo,
            voucherAccountMoney: voucherAccountPayMoney,
            payMethod: "bank_pay",
            goldMoney: totalGoldPayMoney, // 2
            deliveryMoney: deliveryMoney,  // 生产环境没有该属性
            promoteMoney: promoteMoney, // 推广费
          }).then(ret => {
            if (ret.code === 0) {
              this.$message({
                message: this.$t('equipment.paymentSuccess'),
                type: "success"
              });
              this.$emit("bankRransferSuccess");
            } else {
              this.$message.error(this.$getCodeMessage(ret.code, ret.message, ret.messageArgs) || this.$t('equipment.paymentFail'));
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除图片
    handleRemove(file) {
      this.bankRransferForm.fileUrl = "";
      this.bankRransferForm.fileName = "";
	  this.fileList = [];
      this.upload_btn = false;
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleSetUploadData(item) {
      const isLt5M = item.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$refs.upload.clearFiles()
        this.$message({
          message: this.$t('app.uploadFileSize5MB'),
          type: 'warning'
        })
        return false
      }
      let FormDatas = new FormData();
      FormDatas.append("file", item.raw);
      let BASE_URL = getBaseUrl();
      axios
        .post(`${BASE_URL}base/upload/uploadPicture?type=record`, FormDatas, {
          headers: {
            "Content-Type": "multipart/form-data",
            authorization: LoginUserHelper.getUserToken()
          }
        })
        .then(res => {
          console.log("res", res);
          if (res.code == 0) {
            console.log("res.data", res.data);
            let { fileName, uploadPath } = res.data;
            this.bankRransferForm.fileName = fileName;
            this.bankRransferForm.fileUrl = uploadPath;
			this.upload_btn = true;
          } else {
            this.$message.error(this.$getCodeMessage(res.code, res.message, res.messageArgs));
          }
        });
    },
    handleExceed() { },
    previewImage() {
      this.showImageDemo = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.purchase-info {
  color: rgb(74, 131, 232);
  background: rgb(232, 243, 254);
  width: 95%;
  height: 80px;
  margin: 0 auto;
  border-radius: 10px;
  font-size: 14px;
  padding: 10px;
  overflow: hidden;
  margin-bottom: 20px;

  .textOne {
    width: 85%;
    height: 20px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .textTwo {
    width: 85%;
    height: 20px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.PaytoSongShu {
  // padding-left: 24px;
  display: flex;
  margin-bottom: 20px;
  justify-content: center;

  .left_content {
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 120px;
      height: 120px;
    }
  }

  .right_content {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    b {
      font-size: 18px;
      margin-bottom: 20px;
      // margin-left: 28px;
    }
  }
}

.credential-instance {
  text-decoration: underline;
  margin-left: 10px;
  color: #4A83E8;
  cursor: pointer;
}

.preview-demo-image {
  width: 100%;
}
.hide_box {
  :deep(.el-upload--picture-card) {
    display: none;
  }
  :deep(.is-ready) {
    div {
      height: 100%;
    }
  }
}
</style>
